// eslint-disable-next-line import/prefer-default-export
export const devConsolelog = (val, ...others) => {
    if (val && (process.env.REACT_APP_BUILD_TYPE === 'dev' || process.env.REACT_APP_BUILD_TYPE === 'qa')) console.log(val, ...others);
};
